<template>
  <div v-if="company">
    <div class="field">
      <label class="label">ID</label>
      <div class="control">
        <input class="input" type="text" v-model="company.id" disabled />
      </div>
    </div>
    <div class="field">
      <label class="label">Name</label>
      <div class="control">
        <input class="input" type="text" v-model="company.name" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CompanyGeneralTab",
  props: {
    companyData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState(["selectedCompany"]),
    company() {
      return this.companyData || this.selectedCompany;
    },
  },
};
</script>

<style></style>
